import { createContext, ReactElement, useContext } from 'react';
import { ControlledTableColumn, RowType } from './types';
import invariant from 'tiny-invariant';
import { Checkbox } from '@ff-it/ui';
import { ListCampaign } from 'modules/campaign/campaign/types';

type RowSelection = { selected: boolean; disabled: boolean; onChange: (selected: boolean) => void };
type GetRowSelection<T extends RowType> = (data: T) => RowSelection;

const TableSelectionContext = createContext<GetRowSelection<any> | undefined>(undefined);
export const TableSelectionProvider = TableSelectionContext.Provider;

export function useTableSelectionContext<T extends RowType>(): GetRowSelection<T> {
  const ctx = useContext(TableSelectionContext);
  invariant(ctx, 'useTableSelectionContext has to be used within TableSelectionContext');
  return ctx;
}

function SelectionCheckbox({ data }: { data: any }): ReactElement {
  const getRowSelection = useTableSelectionContext();
  const { selected, disabled, onChange } = getRowSelection(data);
  return (
    <Checkbox
      testId="selection-checkbox"
      checked={selected}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
    />
  );
}

export const selectionColumn: ControlledTableColumn<ListCampaign> = {
  key: 'selection',
  required: true,
  width: '40px',
  cellProps: {
    textAlign: 'center',
  },
  render: (data) => <SelectionCheckbox data={data} />,
};
